import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=6b73ffca&scoped=true"
import script from "./salon.vue?vue&type=script&lang=js"
export * from "./salon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73ffca",
  null
  
)

export default component.exports